var map = {
	"./": 2236,
	"./ContentBlock": 5838,
	"./ContentBlock/": 5838,
	"./ContentBlock/index": 5838,
	"./ContentBlock/index.jsx": 5838,
	"./ContentBlock/queries.gql": 4310,
	"./ContentBlock/queries.gql.js": 4310,
	"./ContentBlock/styles.module.scss": 5006,
	"./TwoColContent": 2325,
	"./TwoColContent/": 2325,
	"./TwoColContent/index": 2325,
	"./TwoColContent/index.jsx": 2325,
	"./TwoColContent/queries.gql": 3974,
	"./TwoColContent/queries.gql.js": 3974,
	"./TwoColContent/styles.module.scss": 5412,
	"./TwoColWithMedia": 2084,
	"./TwoColWithMedia/": 2084,
	"./TwoColWithMedia/index": 2084,
	"./TwoColWithMedia/index.jsx": 2084,
	"./TwoColWithMedia/queries.gql": 1488,
	"./TwoColWithMedia/queries.gql.js": 1488,
	"./TwoColWithMedia/styles.module.scss": 8545,
	"./TwoColWithRepeater": 2620,
	"./TwoColWithRepeater/": 2620,
	"./TwoColWithRepeater/index": 2620,
	"./TwoColWithRepeater/index.jsx": 2620,
	"./TwoColWithRepeater/queries.gql": 8466,
	"./TwoColWithRepeater/queries.gql.js": 8466,
	"./TwoColWithRepeater/styles.module.scss": 2986,
	"./index": 2236,
	"./index.js": 2236
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 2184;
module.exports = webpackContext;